export class VesselNotificationDangerousGoods {
    public grossWeight: number = null;
    public numberOfPackages: number = null;
}
